import type { ApolloClient } from '@apollo/client';
import { gql } from '@apollo/client';

import type { AuthState } from 'common/auth/types';
import type { CIError } from 'common/error/error_util';
import type { UserLastPage } from 'common/graphql/types';
import { CILogger } from 'common/log/log.provider';

export const TimeoutConfigCognito = {
    intervalInMs: 1000,
    totalSessionDuration: 10 * 60,
    dialogDuration: 2 * 60,
    storageKey: 'sessionLastActivity',
};

export const TimeoutConfigOkta = {
    totalSessionDuration: 20 * 60,
};

const updateUserLastSavedPages = gql`
    mutation updateUserLastPagesWithInput($pk: String!, $lastPagesOpened: [InputUserLastPage]) {
        updateUserLastPages(userId: $pk, lastPagesOpened: $lastPagesOpened) {
            url
            studyId
            siteId
        }
    }
`;

interface InputUpdateLastSavedPages {
    pk: string;
    lastPagesOpened: UserLastPage[];
}

interface UpdateLastSavedPageResponse {
    updateUserLastPages: UserLastPage[];
}

export function saveLastPagesOpenedAndLogout(
    auth: AuthState,
    client: ApolloClient<unknown>,
    logoutRequest: () => void
) {
    const currentLocation = window.location.pathname + window.location.search;
    const varForUpdatePages: InputUpdateLastSavedPages = {
        pk: auth.activeUser.pk,
        lastPagesOpened: [
            {
                url: currentLocation,
                studyId: auth.activeStudySite.activeStudy?.studyId || null,
                siteId: auth.activeStudySite.activeSite?.siteId || null,
            },
        ],
    };

    client
        .mutate<UpdateLastSavedPageResponse, InputUpdateLastSavedPages>({
            mutation: updateUserLastSavedPages,
            variables: varForUpdatePages,
        })
        .then((response) => {
            logoutRequest();
        })
        .catch((error: CIError) => {
            CILogger.getInstance().info(
                `Unable to save last location for user ${auth.activeUser.pk}. Message: ${error.message}. Last Location: ${window.location.href}`
            );
            // To ensure the kibana logging is done, we delay the logout request by 5 seconds
            setTimeout(() => logoutRequest(), 5000);
        });
}
